<!-- Button for open open widget  -->
<script lang="ts">
	import isPhoneSize from '../helpers/IsPhoneSize';
	import TypingAnimation from './TypingAnimation.svelte';
	import VideoMutButton from './VideoMutButton.svelte';
	import PostMessageHelper from '../helpers/PostMessageHelper';
	import type { Command } from '../models/CommandModel';

	export let avatar: string;
	export let color: string;
	export let isWidgetOpened: boolean;
	export let activatedPulsar = false;
	export let typing: boolean;
	export let isVideoAvatar: boolean;
	let isVideoMuted = true;

	$: zIndex = function (): number {
		let zIndex = 204999;

		if (isWidgetOpened && isPhoneSize()) {
			return zIndex - 1;
		}

		return zIndex;
	};

	// For prevent showing eys of bot & closing animation
	let loaded = false;
	setTimeout(() => {
		loaded = true;
	}, 500);

	PostMessageHelper.subscribeOnMessages((message: { data: Command }) => {
		const command: Command = message.data;
		if (command.name === 'toggleMutVideo') {
			toggleMutVideo();
		}
	});

	function toggleMutVideo() {
		isVideoMuted = !isVideoMuted;
	}
</script>

<div class="wrap-f31sa" style="z-index: {zIndex()};" on:click>
	{#if isVideoAvatar}
		<div class="video-wrap-f32sa">
			<video playsinline autoplay muted={isVideoMuted} loop class="video-f31sa">
				<source src={avatar} type="video/mp4" />
			</video>
		</div>

		<VideoMutButton {isVideoMuted} on:toggle={toggleMutVideo} />
	{:else}
		<button class="button-f31sa" style="background-image: url({avatar})" />
		<!-- Bot eyes -->
		<span
			class="eyes-color"
			style="background-color: {color}"
			class:--visible-hidden-f32sa={!loaded}
		/>
	{/if}

	<!-- Close button -->
	<span
		class:--visible-hidden-f32sa={!loaded}
		style="background-color: {color}"
		class="close-button-f31sa {isWidgetOpened
			? '--opened-f31sa'
			: '--closed-f31sa'}"
	/>

	<!-- Animation pulsar circle -->
	{#if activatedPulsar}
		<span class="--pulsar" style="background-color: {color}" />
	{/if}

	<!-- Typing animation -->
	{#if typing}
		<div class="--typing">
			<TypingAnimation />
		</div>
	{/if}
</div>

<style>
	.wrap-f31sa {
		cursor: pointer;
		width: 72px;
		height: 72px;
		position: fixed;
		right: 16px;
		bottom: 16px;
		border-radius: 50%;
	}
	.button-f31sa {
		padding: 0;
		border-radius: 50%;
		width: inherit;
		height: inherit;
		outline: none;
		border: none;
		background-color: transparent;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}

	.eyes-color {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		position: absolute;
		top: 16px;
		left: 16px;
		z-index: -1;
	}

	.video-wrap-f32sa {
		position: absolute;
		position: relative;
		border-radius: 50%;
		left: 0;
		overflow: hidden;
		right: 0;
		width: 100%;
		height: 100%;
	}

	.video-f31sa {
		width: inherit;
		height: inherit;
	}

	/* Animation pulsar*/
	.--pulsar {
		border-radius: 50%;
		position: absolute;
		z-index: -2;
		top: 0;
		left: 0;
		width: inherit;
		height: inherit;
		animation: pulsar 1500ms forwards infinite;
	}

	.--visible-hidden-f32sa {
		visibility: hidden;
	}

	@keyframes pulsar {
		0% {
			opacity: 0;
		}
		40% {
			opacity: 0.3;
			transform: scale(1.25);
		}

		100% {
			transform: scale(0.5);
		}
	}

	.--typing {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	/* position close button */
	.close-button-f31sa {
		border-radius: 50%;
		top: 0;
		left: 0;
		opacity: 0;
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 100%;
	}

	.close-button-f31sa:before {
		position: absolute;
		content: '';
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		height: 30px;
		width: 8px;
		background: white;
	}

	.close-button-f31sa:after {
		position: absolute;
		content: '';
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		height: 8px;
		width: 30px;
		background: white;
	}

	.--opened-f31sa {
		animation: open 0.5s forwards;
	}

	.--closed-f31sa {
		animation: close 0.5s forwards;
	}

	/* Animation close */
	@keyframes open {
		0% {
			opacity: 0;
		}

		100% {
			transform: rotate(135deg);
			opacity: 1;
		}
	}

	@keyframes close {
		0% {
			transform: rotate(135deg);
			opacity: 1;
		}

		100% {
			transform: rotate(0);
			opacity: 0;
		}
	}
</style>
